import { Icons, defaultTheme } from '@agro-club/agroclub-shared'
import { isLegacyBidCloningEnabled } from 'env'
import { Deal, DealStatusTypes } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { AButton } from 'views/components/Analytics'
import AMobileButton from 'views/components/Analytics/AMobileButton'
import { BidCloningModal } from './BidCloningModal'

interface Props {
  deal: Deal
}

export const BidCloningButton: FC<Props> = ({ deal }) => {
  const [cloningModal, setCloningModal] = useState<boolean>(false)
  const { t } = useTranslation('deal')
  const handlerModal = () => {
    setCloningModal(!cloningModal)
  }
  const isCloningEnabled = isLegacyBidCloningEnabled && deal.status !== DealStatusTypes.DRAFT

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  if (!isCloningEnabled) return null
  return (
    <>
      {!isMobile ? (
        <AButton id="bidCloning" color="secondary" size="medium" onClick={handlerModal}>
          {t('bidCloning')}
        </AButton>
      ) : (
        <AMobileButton id="bidCloning" onClick={handlerModal} color="secondary" Icon={Icons.IconReplace}>
          {t('bidCloning')}
        </AMobileButton>
      )}
      {cloningModal && <BidCloningModal deal={deal} onClose={handlerModal} />}
    </>
  )
}
